//para el build de mazorca
import '../sass/mazorca.scss'


// WEBPACK FOOTER //
// ./resources/assets/js/mazorca.js